import React from 'react'
import { EditableComponent } from '@adobe/aem-react-editable-components'
import {
  Link as UIFoundationsLink,
  LinkTargets
} from '@dcxwam/dcx-wam-ui-foundations'
import { EditableComponentPropsType } from '../../../utils/prop-types'
import withComponentRefresh from '../../../utils/aem/editor/withComponentRefresh'
import { useExtractEditableProps } from '../../../utils/aem/editor/extractEditableProps'
import { LinkWrapperModelProps } from './types'
import LinkWrapperEditConfig from './LinkWrapperEditConfig'
import Container from '../Container/Container'
import {
  withErrorBoundary,
  ErrorFallback
} from '../../functional/ErrorBoundary'

const LinkWrapper = withComponentRefresh(
  (props: EditableComponentPropsType<LinkWrapperModelProps>) => {
    const { cqType, ...rest } = props.model

    const editableProps = useExtractEditableProps(props, rest)

    const { linkUrl, linkTarget, ariaLabel, additionalClasses, id } =
      props.model

    return (
      <EditableComponent {...editableProps}>
        {LinkWrapperEditConfig.isEmpty(props.model) ? (
          LinkWrapperEditConfig.emptyLabel
        ) : (
          <UIFoundationsLink
            linkUrl={linkUrl}
            linkTarget={linkTarget as LinkTargets}
            aria-label={ariaLabel}
            className={additionalClasses}
            id={id}
            fullWidth
          >
            <Container {...editableProps} />
          </UIFoundationsLink>
        )}
      </EditableComponent>
    )
  }
)

const LinkWrapperWithErrorBoundary = withErrorBoundary(LinkWrapper, {
  componentName: 'LinkWrapper',
  fallback: <ErrorFallback componentName="LinkWrapper" />
})

export default LinkWrapperWithErrorBoundary
